<template>
    <div>
        <v-stage :config="{width: 7152, height: 78}" v-if="hoverStage">
            <v-layer ref="hLayer">
                <v-rect :config="{width: 7152,height:78,fill:'#fff',}"></v-rect>
                <v-rect v-for="(item,index) in hRectsConfig" :key="'rect'+index" :config="item"></v-rect>
                <v-line :config="{points: [0, 53.5, 7152, 53.5],stroke: '#5E5E5E',strokeWidth: 1}"></v-line>
                <v-line v-for="(item,index) in hLinesConfig" :key="'line'+index" :config="item"></v-line>
                <v-text v-for="(item,index) in hTextsConfig" :key="'text'+index" :config="item"></v-text>
            </v-layer>
        </v-stage>
        <v-stage v-if="expandURL!=''" :config="{width: 298, height: 78}">
            <v-layer ref="layer" :config="{x:moveMouseX}">
                <v-image :config="{image: imageObj}"/>
            </v-layer>
        </v-stage>
    </div>
</template>
<script>
export default {
    props: {
        baseUnit: Number,
        data: Array,
        MousePx: Number,
        startTime: Number,
        expandURL: String //保证生成图片的函数只执行一次
    },
    data() {
        return {
            hRectsConfig: [],
            hLinesConfig: [],
            hTextsConfig: [],
            hoverStage: true,
            imageObj: null
        };
    },
    created() {
        if (this.expandURL == '') {
            this.createHoverStage();
        } else {
            this.hoverStage = false;
        }
    },
    mounted() {
        if (this.expandURL == '') {
            var url = this.$refs.hLayer.getNode().toDataURL();
            this.hoverStage = false;
            this.$emit('recodeUrl', url);
        }
        let imageObj = new Image();
        imageObj.onload = () => {
            this.imageObj = imageObj;
        };
        var imgUrl = this.expandURL != '' ? this.expandURL : url;
        imageObj.src = imgUrl;
    },
    methods: {
        formatSeconds(value) {
            var secondTime = parseInt(value); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            if (secondTime > 60) {
                //如果秒数大于60，将秒数转换成整数
                //获取分钟，除以60取整数，得到整数分钟
                minuteTime = parseInt(secondTime / 60);
                //获取秒数，秒数取佘，得到整数秒数
                secondTime = parseInt(secondTime % 60);
                //如果分钟大于60，将分钟转换成小时
                if (minuteTime > 60) {
                    //获取小时，获取分钟除以60，得到整数小时
                    hourTime = parseInt(minuteTime / 60);
                    //获取小时后取佘的分，获取分钟除以60取佘的分
                    minuteTime = parseInt(minuteTime % 60);
                }
            }
            var strSecondTime = secondTime.toString();
            var strMinuteTime = minuteTime.toString();
            var strHourTime = hourTime.toString();
            if (parseInt(secondTime) < 10) {
                strSecondTime = '0' + secondTime.toString();
            }
            if (parseInt(minuteTime) < 10) {
                strMinuteTime = '0' + minuteTime.toString();
            }
            if (parseInt(hourTime) < 10) {
                strHourTime = '0' + hourTime.toString();
            }
            var result = strHourTime + ':' + strMinuteTime + ':' + strSecondTime;
            return result;
        },
        createHoverStage() {
            //////////////生成条形图//////////////
            var color = ['#898989', '#009900', '#C6C013', '#EF2917', '#eeeeee']; //绘制的颜色
            var locationX = 0;
            var length = this.data.length;
            var unit = 7152 / (86400 / this.baseUnit);
            var hRectsConfig = [];
            for (let i = 0; i < length; i++) {
                let width = this.data[i].number * unit;
                let obj = new Object({
                    x: locationX,
                    y: 0,
                    width: width,
                    height: 48,
                    fill: color[this.data[i].status]
                });
                // 设置下一个元素具体的位置
                locationX += width;
                hRectsConfig.push(obj);
            }
            this.hRectsConfig = hRectsConfig;
            //////////////生成刻度尺//////////////
            var timeCall = 600; //两条竖线之间表示多长时间
            var allTime = 24 * 6;
            var UnitCall = (timeCall / this.baseUnit) * unit;
            var locationRule = 0;
            var hLinesConfig = [];
            var hTextsConfig = [];
            var createTime = 0; //创建竖线的次数
            do {
                let objLine = new Object({
                    points: [locationRule + 0.5, 53, locationRule + 0.5, 63],
                    stroke: '#5E5E5E',
                    strokeWidth: 1
                });
                if (createTime == allTime) {
                    objLine.points = [locationRule - 0.5, 53, locationRule - 0.5, 63];
                }
                hLinesConfig.push(objLine);
                if (createTime % 2 == 0) {
                    var time = Math.round((locationRule * this.baseUnit) / unit) + this.startTime;
                    time = time <= 86400 ? time : time - 86400; // 秒
                    var objText = new Object({
                        x: locationRule,
                        y: 63,
                        text: this.formatSeconds(time),
                        fontSize: 14,
                        fill: '#111'
                    });
                    if (createTime == allTime) {
                        objText.x = objText.x - 54;
                    } else if (createTime != 0) {
                        objText.x = objText.x - 54 / 2;
                    }
                    hTextsConfig.push(objText);
                }
                createTime++;
                locationRule += UnitCall;
            } while (createTime <= allTime);
            this.hLinesConfig = hLinesConfig;
            this.hTextsConfig = hTextsConfig;
        }
    },
    computed: {
        moveMouseX() {
            var smallUnit = 1440 / (86400 / this.baseUnit);
            var expandUnit = 7152 / (86400 / this.baseUnit);
            var time = Math.round(((this.MousePx - 50) * this.baseUnit) / smallUnit);
            var px = (time * expandUnit) / this.baseUnit; //此时应该放大的位置
            var pxHalfhour = (1800 * expandUnit) / this.baseUnit;
            return -(px - pxHalfhour);
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/views/oeetable/components/magnifier.vue